import type {
  AssetRiskFieldProps,
  AssetRiskFieldValue,
} from "./asset-risk-field.type";

import { useTranslation } from "react-i18next";

import { FieldSelectTag } from "@/ui/field-select-tag";

import { getAssetRiskMutateValue } from "./asset-risk-field.helper";
import { useAssetRiskField } from "./asset-risk-field.hook";

import "./asset-risk-field.style.less";

export const AssetRiskField = ({
  label,
  onChange,
  ...fieldProps
}: AssetRiskFieldProps) => {
  const { t } = useTranslation();

  const { options } = useAssetRiskField();

  return (
    <FieldSelectTag
      {...fieldProps}
      label={label}
      options={options}
      onChange={(value: AssetRiskFieldValue) => {
        onChange?.(getAssetRiskMutateValue(value));
      }}
      aria-label={label ?? t("asset:risk.label")}
      dropdownClassName="asset-risk-field-dropdown"
    />
  );
};
